<template>
  <section class="section upload-page">

    <b-breadcrumb :items="[
        { text: 'Caricamento dati' }
        ]">
    </b-breadcrumb>

    <status></status>

    <multi-upload />

    <b-card title="Importa dati caricati">
      <b-row>
        <b-col>
          <p>Selezionare una o più righe per re-importare i dati</p>
        </b-col>
      </b-row>
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :search-options="{
          enabled: true
        }"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: false, 
        }"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 20,
          position: 'bottom',
          perPageDropdown: [10, 20, 50, 100],
          dropdownAllowAll: true,
          setCurrentPage: 1,
          jumpFirstOrLast : true,
          firstLabel : 'First Page',
          lastLabel : 'Last Page',
          nextLabel: 'next',
          prevLabel: 'prev',
          rowsPerPageLabel: 'Rows per page',
          ofLabel: 'of',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        }"
        ref="data-sheets" 
        row-style-class="table-row"
        @on-selected-rows-change="selectSheet"
      >

        <template slot="selected" slot-scope="{ rowSelected }">
          <span v-if="rowSelected">✔</span>
        </template>
        <template slot="info" slot-scope="data">
          <span v-if="data.item.type == 'xlsx' && !data.item.info">
            <button @click="getInfo(data.item)" variant="primary" size="sm">Info</button>
          </span>
          <p v-if="data.item.info">
            {{ data.item.info.intervalName }}
            <ul>
              <li v-for="c in data.item.info.channels" :key="c.code">{{ c.code }} ({{c.name}})</li>
            </ul>
          </p>
        </template>
      </vue-good-table>
      <b-row class="mt-3" v-if="selectedDatasheets.length > 0">
        <b-col>
          <b-btn @click="goImportSelected()" size="lg" variant="warning">Avvia importazione ({{ selectedDatasheets.length }}) selezionati</b-btn>
        </b-col>
      </b-row>
    </b-card>
          
    <b-modal id="modalConfirm"
      ref="modal"
      centered
      title="Conferma importazione"
      header-bg-variant="warning"
      ok-title="Procedi"
      ok-variant="warning"
      @ok="goImport">
      <p>Procedere con l'importazione dei dati?</p>
    </b-modal>

    <b-modal id="modalCopy"
      ref="modalCopy"
      title="Conferma copia"
      header-bg-variant="warning"
      ok-title="Procedi"
      @ok="goCopy">
      <p>Procedere con la copia dei dati
        <strong>{{ copyText }}</strong>
        dal <strong>{{ fromDate }} al {{ toDate }}</strong>?
      </p>
    </b-modal>

    <b-modal 
      id="progressModal"
      ref="progressModal"
      centered
      title="Importazione"
      :hide-header="true"
      :hide-footer="true"
      :no-close-on-backdrop="true"
    >
      <b-progress-bar value="100" variant="success" striped :animated="true">
        Importazione in corso...
      </b-progress-bar>
    </b-modal>
  </section>
</template>

<script>
import Vue from 'vue';
import Status from './Status';
import MultiUpload from './MultiUpload';
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
import 'vue-good-table/dist/vue-good-table.css';
import { VueGoodTable } from 'vue-good-table';
import api from '@/services/api';

var VueCookie = require('vue-cookie')
var moment = require('moment');

export default {
  name: "UploadData",
  components: { DatePick, Status, MultiUpload, VueGoodTable },
  data() {
    return {
      name: null,
      files: [],
      warning: "",
      warningDetails: "",
      interval: null,
      channels: [],
      showPreview: false,
      datasheetId: 0,
      complete: false,
      copyText: "",
      copyType: null,
      datasheets: [],
      copyDatasheets: [],
      selectedDatasheets: [],
      fromDate: moment().add(-1, 'months').startOf('month').format("DD/MM/YYYY"),
      toDate: moment().startOf('month').format("DD/MM/YYYY"),
      datasheetsFields: ['id', 'date', 'fileName', 'type', 'info'],
      rows: [],
      columns: [
        {
          label: 'Id',
          field: 'id',
          type: 'number'
        },
        {
          label: 'Date',
          field: 'date',
          type: 'date',
          dateInputFormat: 'dd/MM/yyyy',
          dateOutputFormat: 'dd/MM/yyyy'
        },
        {
          label: 'File Name',
          field: 'fileName',
        },
        {
          label: 'Type',
          field: 'type',
        },
        {
          label: 'Info',
          field: 'info',
        },
      ],
    }
  },
  computed: {
    headers() {
      return {
        Authorization: VueCookie.get("token")
      }
    },
    monthLabels() {
      return 'Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic'.split('_')
    },
    monthsNames() {
      return this.$store.state.utils.months
    },
    daysNames() {
      return this.$store.state.utils.daysShort
    },
  },
  mounted() {
    this.token = VueCookie.get("token")
    this.$store.dispatch('datasheets/list').then( data => {
      this.datasheets = data.map(item => {
        let o = _.clone(item)
        item.info = "";
        return item
      })
      this.rows = data;
      // this.rows = this.rows.concat(this.rows).concat(this.rows);
    })
  },
  methods: {
    getInfo(row) {
      this.$store.commit("loading")
      this.$store.dispatch("datasheets/info", row.id).then((data) => {
        this.$store.commit("stopLoading")
        _.find(this.datasheets, { id: row.id }).info = data
      })  
    },
    selectSheet() {
      const selectedRows = this.$refs['data-sheets'].selectedRows;
      this.selectedDatasheets = selectedRows.map(r => r.id);
    },
    isFutureDate(date) {
      const currentDate = new Date();
      return date > currentDate;
    },
    goCalculate() {
      this.$store.commit("loading")
      this.$store.dispatch("datasheets/applySlots").then(() => {
        this.$store.commit("stopLoading")
      })
    },
    copyConfirm(type) {

      if(! this.fromDate || ! this.toDate) {
        Vue.toasted.show('Selezionare il periodo', {
          duration: 3000,
          theme: "bubble"
        })
        return
      }

      this.copyType = type
      if(type === "1-15")
        this.copyText = "da 1' a 15'"
      if(type === "15-60")
        this.copyText = "da 15' a 60'"
      if(type === "60-d")
        this.copyText = "da 60' a giornaliero"
      if(type === "d-w")
        this.copyText = "da giornaliero a settimanale"
      if(type === "d-m")
        this.copyText = "da giornaliero a mensile"
      if(type === "m-y")
        this.copyText = "da mensile ad annuale"

      this.$refs.modalCopy.show()
    },
    goCopy() {
      let params = {
        type: this.copyType,
        from: parseInt(moment(this.fromDate, 'DD/MM/YYYY').format("YYYYMMDD")),
        to: parseInt(moment(this.toDate, 'DD/MM/YYYY').format("YYYYMMDD"))
      }
      if(this.copyType == 'd-m') {
        params.from = parseInt(moment(this.fromDate, 'DD/MM/YYYY').format("YYYYMM"))
        params.to = parseInt(moment(this.toDate, 'DD/MM/YYYY').format("YYYYMM"))
      }
      this.$store.commit('loading')
      this.$store.dispatch('datasheets/fillData', params).then(() => {
        this.$store.commit('stopLoading')

        Vue.toasted.show('Operazione completata', {
          duration: 3000,
          theme: "bubble"
        })
      })
    },
    itemStatus(item) {
      if(item.status == 1)
        return 'info'

      if(item.status == 0)
        return 'warning'

      if(item.status == -1)
        return 'alert'
    },
    inputFile(newFile, oldFile) {
      this.complete = false
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        this.$store.commit("stopLoading")
        if (newFile.xhr && newFile.xhr.status == 200) {
          //  Get the response status code
          this.interval = newFile.response.data.interval
          this.intervalName = newFile.response.data.intervalName
          this.channels = newFile.response.data.channels
          this.datasheetId = newFile.response.data.id
          this.showPreview = true
          this.$refs.upload.clear()
        } else {
          this.warning = "Errore nel caricamento del file";
          this.warningDetails = newFile.response.message;
        }
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      this.warning = "";
      this.warningDetails = "";
      if (newFile && !oldFile) {
        if (!/\.xlsx$/i.test(newFile.name)) {
          this.warning = "Selezionare un file in formato XLSX";
          return prevent();
        }
      }

      // Create a blob field
      newFile.blob = '';
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }

      this.$store.commit("loading");
      this.$refs.upload.active = true;
    },
    async goImportSelected() {
      this.$nextTick(() => {
        this.$bvModal.show('progressModal');
      });

      for(let i = 0; i < this.selectedDatasheets.length; i++) {
        await this.goImportSheetId(this.selectedDatasheets[i]);
      }

      this.$nextTick(() => {
        this.$bvModal.hide('progressModal');
      });
    },
    goImport() {
      goImportSheetId(this.datasheetId);
    },
    async goImportSheetId(id) {
      const response = await api().get(`/datasheets/import/${id}`);

      if(response.data.code == 1) {
        this.showPreview = false;
        this.complete = true;
        this.$notify({
          type: "success",
          title: 'Successo',
          text: "Importazione completata"
        });  
      } else {
        this.$notify({
          type: "error",
          text: response.message,
          title: 'Errore',
        });
      }
    }
  }
}
</script>

<style>
.upload-page .vdpComponent.vdpWithInput>input {
  padding: 10px;
  font-size: 14px;
}
.table-row {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Import/Import.vue